import React from 'react';
import { CardTitle, Typography, Link } from '@one-thd/sui-atomic-components';
import { purchaseHistoryURL } from '../../../../constants';

export const RecentOrdersCardHeader = () => {
  return (
    <CardTitle
      data-testid="recentOrders-header"
      header={(
        <Typography variant="h3" weight="regular">Your Latest Orders</Typography>
      )}
      action={<Link href={purchaseHistoryURL} data-testid="recent-orders-view-all">View All</Link>}
      disableActionSpacing
    />
  );
};
